import { render, staticRenderFns } from "./App.vue?vue&type=template&id=9f7c89c4&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=9f7c89c4&prod&lang=less&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=9f7c89c4&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7c89c4",
  null
  
)

export default component.exports